import React from 'react';
// @ts-expect-error: no TS support for this lib.
import { NotificationManager } from 'react-notifications';
import { postErrorToServer, userAction } from '@/util/helpers/ajax-helpers';

const GlobalErrorNotification: React.FC = () => {
  React.useEffect(() => {
    window.addEventListener('error', handleErrors);

    return () => window.removeEventListener('error', handleErrors);
  }, []);

  return null;
};

function handleErrors(evt: ErrorEvent) {
  if (evt.error) {
    // NOTE: evt.error is only populated for same-origin (so doesn't work for webpack development server)
    // in live
    postErrorToServer(evt.error.stack);
    userAction('error-on-client');
  } else if (window.location.protocol.indexOf('https') === -1) {
    // in dev mode (so shout loudly)
    NotificationManager.error(
      'Check developer console for details', // body
      'Unexpected error occurred', // title
      10 * 1000,
    );
  }
}

export default GlobalErrorNotification;
